import {ISsrType} from "../../../ssr-types/ssr-types.service.interface";
import {NullableUndefinedString} from "../../../../types/nullable-types";
import {IServiceFactory} from "../../../service-factory.interface";

export class BundleSsrUpgradeNote {
    constructor(public readonly fromSsrType: ISsrType) {
    }

    toString(): string {
        return `upgrade|${this.fromSsrType.ssrCode}`;
    }

    public static tryParse(note: NullableUndefinedString, services: IServiceFactory): BundleSsrUpgradeNote | null {
        if(!note) {
            return null;
        }

        const noteParts = note.split("|");

        if(noteParts[0]?.toLowerCase() !== "upgrade") {
            return null;
        }

        const ssrCode = noteParts[1]?.toUpperCase();
        if(!ssrCode) {
            return null;
        }

        return new BundleSsrUpgradeNote(services.ssrTypes.getSsrType(ssrCode));
    }
}